/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Member_Login_Method_SsoInputs */



/**
* | output |
* | --- |
* | "Sign in with {provider}" |
*
* @param {Member_Login_Method_SsoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_method_sso = /** @type {((inputs: Member_Login_Method_SsoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Method_SsoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Anmeldung mit ${i?.provider}`)
	return /** @type {LocalizedString} */ (`Sign in with ${i?.provider}`)
});